export const getMylounge = state => state.myloungeLegacy;

export const getTabs = state => state.myloungeLegacy.tabs;

export const getAllCampaigns = state => state.myloungeLegacy?.open?.campaigns || {};

export const getAllOpenCampaigns = state => Object.values(getAllCampaigns(state));

export const getOpen = state => state.myloungeLegacy.open;

export const getUpcoming = state => state.myloungeLegacy.upcoming;

export const getRecommendations = state => state.myloungeLegacy.recommendation;

export const getSelectedFilter = state => state.myloungeLegacy.selectedFilter;

export const getCategorySlideIndex = state => state.myloungeLegacy.categorySlideIndex;

export const getIsWelcomeBoxOpen = state => state.myloungeLegacy.isWelcomeBoxOpen;

export const getIsLoading = state => state.myloungeLegacy.isLoading;

export const getHasCampaigns = state => Object.keys(getAllCampaigns(state)).length > 0;

export const getErrors = state => state.myloungeLegacy.errors;

export const getImagesLoaded = state => state.myloungeLegacy.imagesLoaded;

export const getCampaignsForHeader = state => getAllOpenCampaigns(state)
    .map(({ topNaviImageUrl, campaignIdentifier, name, hasLogo }) => ({
        imageUrl: topNaviImageUrl,
        name,
        campaignIdentifier,
        hasLogo,
    }));
